import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className, y = 24 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "block" }) => (
    <span className="block overflow-hidden pb-1">
        <motion.span
            className={className}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);
